<div class="company-header" *ngIf="hasSalesHistoryCompany()">
  <a class="btn-back" (click)="backToSalesHistorySummary()">
    <mat-icon aria-hidden="false">west</mat-icon>
    <span>VOLTAR</span>
  </a>
  <div class="company-card">
    <div class="company-logo">
      <img src="./assets/icons/no-logo-company-icon.svg" />
    </div>
    <div class="company-data">
      <div class="company-name">
        {{ getSalesHistoryCompany().getCorporateName() }}
      </div>
      <span class="company-cnpj">
        CNPJ:
        {{ getSalesHistoryCompany().getFiscalNumber() | companyFederalNumber }}
      </span>
      <span class="company-lives">{{ getSalesHistoryCompany().getEmployeeCount() }} Vidas</span>
    </div>
  </div>
</div>
<div class="metrics-container" *ngIf="hasSalesHistoryCompany()">
  <div class="metric-card" style="background-color: #0f1642">
    <span class="metric-label">Produtos<br />Vendidos</span>
    <span class="metric-value">{{ getSalesHistoryCompany().getSalesHistorySummary().getProductSoldCount() }}</span>
  </div>
  <div class="metric-card" style="background-color: #28c76f">
    <span class="metric-label">Valores<br />Gerados</span>
    <span class="metric-value">{{ getSalesHistoryCompany().getSalesHistorySummary().getSalesValueableCount() | currencyPbmPipe }}</span>
  </div>
  <div class="metric-card" style="background-color: #ffa84c">
    <span class="metric-label">Subsídio<br />Praticado</span>
    <span class="metric-value">{{ getSalesHistoryCompany().getSalesHistorySummary().getSalesSubsidyValueCount() | currencyPbmPipe }}</span>
  </div>
  <div class="metric-card" style="background-color: #e95456">
    <span class="metric-label">Desconto<br />em folha</span>
    <span class="metric-value">{{ getSalesHistoryCompany().getSalesHistorySummary().getPaymentrollValueCount() | currencyPbmPipe }}</span>
  </div>
</div>
<div *ngIf="hasSalesHistoryCompany()">
  <form [formGroup]="filterForm" class="filters-container">
    <mat-form-field>
      <mat-label>Data inicial</mat-label>
      <input
        formControlName="startDate"
        matInput
        type="text"
        placeholder="Data inicial"
        (change)="onFilterChange()"
        [textMask]="{ mask: dataMask, guide: true, keepCharPositions: true }" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Data final</mat-label>
      <input
        formControlName="endDate"
        matInput
        type="text"
        placeholder="Data final"
        (change)="onFilterChange()"
        [textMask]="{ mask: dataMask, guide: true, keepCharPositions: true }" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Por Fabricante</mat-label>
      <input formControlName="productManufacturer" matInput type="text" placeholder="Por Fabricante" (change)="onFilterChange()" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Por Tipo de Produto</mat-label>
      <mat-select formControlName="productType" (selectionChange)="onFilterChange()">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let type of getProductTypes()" [value]="type.getValue()">{{ type.getValue() }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div class="product-list-container" *ngIf="hasSalesHistoryCompany()">
  <div class="product-card" *ngFor="let item of getSalesHistoryCompany().getcompanySalesHistoryItemList()">
    <div class="column-start div_column">
      <span class="title">Medicamento/Produto</span>
      <span class="value" matTooltip="{{ item.getProductName() }}">{{ item.getProductName() }}</span>
    </div>
    <div class="data div_column">
      <span class="title">Quantidade</span>
      <span class="value" matTooltip="{{ item.getSoldItemCount() }}">{{ item.getSoldItemCount() }}</span>
    </div>
    <div class="data div_column">
      <span class="title">Região</span>
      <span class="value" matTooltip="{{ item.getStateName() }}">{{ item.getStateName() }}</span>
    </div>
    <div class="data div_column">
      <span class="title">Rede</span>
      <span class="value" matTooltip="{{ item.getNetworkName() }}">{{ item.getNetworkName() }}</span>
    </div>
    <div class="data column-end div_column">
      <span class="title">Valor Gerado</span>
      <span class="value" matTooltip="{{ 'R$ ' + item.getSoldValueCount().toFixed(2) }}">{{ item.getSoldValueCount().toFixed(2) | currencyPbmPipe }}</span>
    </div>
  </div>
  <div fxLayoutAlign="end end">
    <a class="more-companies-btn" *ngIf="hasSalesHistoryCompanyItem()"><span (click)="searchMore()">carregar mais registros</span></a>
  </div>
</div>
